import React from 'react';

import { Route, Routes } from 'react-router-dom';

import { RequestDetail, RequestQueue } from './components';

const ProvisioningRequests: React.FC = () => (
  <Routes>
    <Route path="/" element={<RequestQueue />} />
    {/* The notification email deep-links here, so the id lives in the path. */}
    <Route path=":requestId" element={<RequestDetail />} />
  </Routes>
);

export default ProvisioningRequests;
